import { css } from 'lit-element';

export const overrideDesignTokens = css`
  :host {
    --colours-brand-primary: var(--theme-link-color, var(--colours-brand-primary));
    --colours-brand-secondary: var(--theme-header-color, var(--colours-brand-secondary));
  }
`;
